import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import EditIcon from '@mui/icons-material/Edit';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import TextField from '@mui/material/TextField';
import TextEditor from './TextEditor';
import { Box } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UpdateContent({callback, post}) {
  const [open, setOpen] = React.useState(false);
  const [title, setTitle] = React.useState(post.title || ''); // Initialize with post.title or an empty string
  const [content, setContent] = React.useState(post.content || ''); // Initialize with post.content or an empty string

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value); // Update the title state with the new value from TextField
  }

  const handleContentChange = (newContent) => {
    setContent(newContent); // Update the content state with the new content
  }

  const handleCallback = () => {
    if(typeof callback === 'function') {
        callback(title, content);
    }
  }

  return (
    <Box>
      <IconButton onClick={handleClickOpen}>
        <EditIcon />
      </IconButton>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant='h6' color={'white'} component="div">
              Edit Post
            </Typography>
            <Button autoFocus color="inherit" onClick={() => {
                handleCallback();
                handleClose();
            }}>
              save & update
            </Button>
          </Toolbar>
        </AppBar>
        <List sx={{ height: '90vh' }}>
          <ListItem>
            <TextField
                id="title"
                label="Post title"
                placeholder="Post title"
                helperText="The title of the post"
                value={title} // Bind the value of TextField to title state
                variant="standard"
                required
                onChange={handleTitleChange} // Call handleTitleChange on change
            />
          </ListItem>
          <Divider />
          <ListItem sx={{ height: '65%' }}>
            <TextEditor
                onContentChange={handleContentChange}
                initialContent={content} // Bind the initial content to the editor
            />
          </ListItem>
        </List>
      </Dialog>
    </Box>
  );
}
